export default __webpack_public_path__ + "static/media/css-logo.463e319b.png";